import { Box, useMediaQuery, useTheme } from "@material-ui/core";
import { toFixed } from "src/services/utils";
import BaseOption from "../components/BaseOption";
import FigureText from "../components/FigureText";

export default function Incentive({ asset, ...props }) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.only("xs"));

  return (
    <>
      <BaseOption hideEdit={true} {...props}>
        <Box display="flex" justifyContent="flex-start" alignItems="center" flexWrap="wrap">
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="Token Incentive"
            value={"0x123"}
            mr={matches ? 0 : 8}
            justifyContent={matches ? "space-between" : "flex-start"}
            width={matches ? "100%" : "inherit"}
          />
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="EPS for Depositor"
            value={asset.tTokenEPS ? toFixed(asset.tTokenEPS, 3) : "---"}
            mr={matches ? 0 : 8}
            justifyContent={matches ? "space-between" : "flex-start"}
            width={matches ? "100%" : "inherit"}
          />
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="EPS for Borrower"
            value={asset.dTokenEPS ? toFixed(asset.dTokenEPS, 3) : "---"}
            mr={matches ? 0 : 8}
            justifyContent={matches ? "space-between" : "flex-start"}
            width={matches ? "100%" : "inherit"}
          />
        </Box>
      </BaseOption>
    </>
  );
}
